import { isValidCPF, isValidCNPJ } from "@brazilian-utils/brazilian-utils";

export function validarCPF(CPF: string | undefined) {
  if (CPF === undefined) return false;

  return isValidCPF(CPF) || isValidCNPJ(CPF); // false;
}
